export enum PurchaseFeed {
  INDEX = '/purchase-feed',
}
